import { render, staticRenderFns } from "./presAddSport.vue?vue&type=template&id=312397ba&scoped=true&"
import script from "./presAddSport.vue?vue&type=script&lang=ts&"
export * from "./presAddSport.vue?vue&type=script&lang=ts&"
import style0 from "./presAddSport.vue?vue&type=style&index=0&id=312397ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312397ba",
  null
  
)

export default component.exports